import React, { Component, Fragment } from 'react';
import Form from './Form';

export default class Login extends Component {
    render() {
        return (
            <div className="card bg-secondary shadow border-0">
                <div className="card-body px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                        <small>Insira seu CPF ou email para recuperar seu acesso</small>
                    </div>
                    <Form />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/ResetPassword/index.js